import { SignInPageErrorMessage } from '@core/auth/types';

export const isRetryingMessage = 'Something went wrong. Trying again.';
export const timeWindowUserIsBlockedByGuessingWrongOTP = '24 hours';
export const timeWindowUserIsBlockedFromSelectingChallenge = '10 minutes';
export const signInPageErrorMessages: SignInPageErrorMessage = {
    binding_code_attempts_limit_exceeded: `You've exceeded the allowed number of unsuccessful login attempts. You may try again in ${timeWindowUserIsBlockedByGuessingWrongOTP}.`,
    invalid_credentials:
        'The email/password combination you entered is incorrect.',
    invalid_request: 'The email/password combination you entered is incorrect.',
};

export const attemptsLimitReachedTexts = {
    challenge: `You've exceeded the allowed number of attempts to select your verification method. You may try again in ${timeWindowUserIsBlockedFromSelectingChallenge}.`,
    otp: `You've exceeded the allowed number of attempts to confirm your security code. You may try again in ${timeWindowUserIsBlockedByGuessingWrongOTP}.`,
};

export const DUPLICATE_ERROR_MESSAGE =
    'Name must be unique. Please enter a unique name for this payment method.';

export const paymentJustMadeTimestampLSKey = 'oas_payment_just_made';

export const OAS_APP_VERSION = 'oas_app_version';

export const PRESERVED_QUERY_PARAMS_KEY = 'oas:preservedQueryParams';

export const UTM_OVERRIDE_KEYS = new Set([
    'utm_source',
    'utm_campaign',
    'utm_medium',
    'utm_term',
    'utm_content',
]);
